/**
 * FREED Word-by-Word Text Animation
 * Splits section headings into individual word spans.
 * Each word fades up with a 50ms stagger.
 * Marks headings with data-freed-words-init so P3-1 (initTextAnimations) skips them.
 */
(function () {
  'use strict';

  function splitIntoWords(heading) {
    // Already processed
    if (heading.hasAttribute('data-freed-words-init')) return;

    var text = heading.textContent.trim();
    if (!text) return;

    var words = text.split(/\s+/);

    // Wrap each word in a span with staggered transition-delay
    heading.innerHTML = words.map(function (word, i) {
      return (
        '<span class="freed-word" style="transition-delay:' +
        (i * 0.05) +
        's">' +
        // Escape HTML entities in case of special chars
        word
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;') +
        '</span>'
      );
    }).join(' ');

    heading.setAttribute('data-freed-words-init', '1');
  }

  function initWordAnimations() {
    // Target all headings inside freed sections
    var headings = document.querySelectorAll(
      '.freed-section h1, .freed-section h2, .freed-section h3'
    );

    headings.forEach(splitIntoWords);

    // IntersectionObserver: reveal words when heading scrolls into view
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.querySelectorAll('.freed-word').forEach(function (word) {
            word.classList.add('freed-word--visible');
          });
          obs.unobserve(entry.target);
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -30px 0px' }
    );

    document
      .querySelectorAll('[data-freed-words-init]')
      .forEach(function (el) {
        obs.observe(el);
      });
  }

  // Deferred scripts run after parsing — DOM is ready.
  // Use DOMContentLoaded as a safety fallback.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWordAnimations);
  } else {
    initWordAnimations();
  }
})();
